// extracted by mini-css-extract-plugin
export default {"cnt":"LoginModule_cnt__cfD-J","login":"LoginModule_login__Oyyxl","logo":"LoginModule_logo__AP4un","form":"LoginModule_form__OCR1o","sidebar":"LoginModule_sidebar__G0CWz"};